import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "@/lib/api";

// 80mm thermal receipt template. `@page size: 80mm auto` matches typical
// 3-inch thermal roll printers set as the OS default.
export default function POSBillPrint() {
  const { id } = useParams();
  const [b, setB] = useState(null);
  const [store, setStore] = useState(null);

  useEffect(() => {
    api.get(`/pos/bills/${id}`).then(async (r) => {
      setB(r.data);
      if (r.data?.store_id) {
        const s = await api.get("/sales/branches");
        setStore((s.data || []).find((x) => x.id === r.data.store_id));
      }
      setTimeout(() => window.print(), 400);
    });
  }, [id]);

  if (!b) return <div className="p-6 text-center">Loading…</div>;
  const t = b.totals || {};
  return (
    <div className="bg-white text-black min-h-screen">
      <div className="p-2 receipt" style={{ width: "72mm", fontFamily: "'Menlo', monospace", fontSize: "10pt" }}>
        <div style={{ textAlign: "center" }}>
          <div style={{ fontSize: "12pt", fontWeight: 700 }}>{store?.name || "Thara Gold"}</div>
          {store?.address_line1 && <div style={{ fontSize: "8pt" }}>{store.address_line1}</div>}
          {store?.gstin && <div style={{ fontSize: "8pt" }}>GSTIN: {store.gstin}</div>}
          {store?.mobile && <div style={{ fontSize: "8pt" }}>Tel: {store.mobile}</div>}
        </div>
        <div style={{ borderTop: "1px dashed #000", margin: "4px 0" }} />
        <div style={{ display: "flex", justifyContent: "space-between", fontSize: "8pt" }}>
          <span>Bill: <b>{b.bill_no}</b></span>
          <span>{new Date(b.created_at).toLocaleString()}</span>
        </div>
        <div style={{ fontSize: "8pt" }}>Cust: {b.customer_name}{b.customer_mobile ? ` · ${b.customer_mobile}` : ""}</div>
        <div style={{ fontSize: "8pt" }}>Terminal: {b.terminal_code} · {b.created_by_name}</div>
        {b.is_return && <div style={{ textAlign: "center", background: "#000", color: "#fff", padding: "1px 0", margin: "2px 0", fontWeight: 700 }}>REFUND</div>}
        <div style={{ borderTop: "1px dashed #000", margin: "4px 0" }} />
        <table style={{ width: "100%", fontSize: "9pt" }}>
          <thead>
            <tr style={{ borderBottom: "1px dashed #000" }}>
              <th style={{ textAlign: "left" }}>Item</th>
              <th style={{ textAlign: "right", width: "18px" }}>Qty</th>
              <th style={{ textAlign: "right" }}>Rate</th>
              <th style={{ textAlign: "right" }}>Amt</th>
            </tr>
          </thead>
          <tbody>
            {(b.lines || []).map((l, i) => {
              const net = (l.qty * l.rate) - (((l.qty * l.rate) * (l.discount_pct || 0) / 100) + (l.discount_amount || 0));
              return (
                <tr key={i}>
                  <td>{l.product_name}<div style={{ fontSize: "7pt", opacity: 0.7 }}>{l.product_sku}</div></td>
                  <td style={{ textAlign: "right" }}>{l.qty}</td>
                  <td style={{ textAlign: "right" }}>{Number(l.rate).toFixed(2)}</td>
                  <td style={{ textAlign: "right" }}>{Number(net).toFixed(2)}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
        <div style={{ borderTop: "1px dashed #000", margin: "4px 0" }} />
        <Row k="Sub-total" v={t.subtotal} />
        {(t.line_discount || 0) > 0 && <Row k="Disc" v={-t.line_discount} />}
        {(t.bill_discount || 0) > 0 && <Row k="Bill Disc" v={-t.bill_discount} />}
        {Object.entries(t.tax_summary || {}).map(([k, v]) => <Row key={k} k={`Tax ${k}`} v={v} />)}
        <div style={{ borderTop: "1px dashed #000", margin: "4px 0" }} />
        <div style={{ display: "flex", justifyContent: "space-between", fontSize: "13pt", fontWeight: 700 }}>
          <span>TOTAL</span><span>₹{Number(t.grand_total || 0).toFixed(2)}</span>
        </div>
        <div style={{ borderTop: "1px dashed #000", margin: "4px 0" }} />
        {(b.payments || []).map((p, i) => <Row key={i} k={`${p.mode.toUpperCase()}${p.reference ? " · " + p.reference : ""}`} v={p.amount} />)}
        <div style={{ borderTop: "1px dashed #000", margin: "4px 0" }} />
        <div style={{ textAlign: "center", fontSize: "8pt" }}>Thank you! Please visit again.</div>
      </div>

      <style>{`
        @media print {
          @page { size: 80mm auto; margin: 0; }
          html, body { background: #fff !important; }
          .receipt { width: 76mm !important; }
        }
      `}</style>
    </div>
  );
}

function Row({ k, v }) {
  return <div style={{ display: "flex", justifyContent: "space-between", fontSize: "9pt" }}><span>{k}</span><span>₹{Number(v || 0).toFixed(2)}</span></div>;
}
